import React from 'react';
import clsx from 'clsx';

interface LoadingSpinnerProps {
  size?: 'small' | 'medium' | 'large';
  className?: string;
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 'medium',
  className,
}) => {
  return (
    <div className={clsx('loading-spinner', `loading-spinner--${size}`, className)}>
      <div className="spinner"></div>
    </div>
  );
};

